import React from 'react';
import {observer} from 'mobx-react';
import {clsx} from 'clsx';
import {ISearchItem} from '../Search/Search';
import SearchResult from "../SearchResult/SearchResult";
import './SearchPopup.scss';

interface ISearchResultProps {
    isNotFound: boolean;
    query: string;
    searchList: ISearchItem[];
}

const SearchPopup: React.FC<ISearchResultProps> = ({isNotFound, query, searchList}) => {
    // Флаг показа результатов поиска.
    const showSearchResult = !!searchList.length && query.length > 2;
    // Флаг показа сообщения о минимальном числе символов.
    const showCountMessage = query.length > 0 && query.length < 3;
    // Флаг показа сообщения 'Ничего не найдено'.
    const showNotFoundMessage = isNotFound && query.length > 2;
    // Флаг скрытия поп-апа.
    const hidePopup = !showNotFoundMessage && !showSearchResult && !showCountMessage;

    const className = clsx('search-popup', {hidden: hidePopup});

    return (
        <div className={className}>
            {showSearchResult && <SearchResult searchList={searchList} query={query} />}

            {showCountMessage && <div className="search-symbol-count">Введите более двух символов</div>}

            {showNotFoundMessage && <div className="search-not-found">Ничего не найдено.<br />Попробуйте изменить запрос.</div>}
        </div>
    );
}

export default observer(SearchPopup);
